import "slick-carousel";
(function ($) {
  "use strict";
  $(function () {
    $(".carousel-companies").slick({
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 6,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 639,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    $(".carousel-blog").slick({
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 3,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 639,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
})(jQuery);
